 <div class="container">
    <div class="row">
      <div class="col-md-11 col-lg-8 col-xl-7 col-xxl-6 mx-auto text-center">
        <h2 class="display-2 mb-4 default-pattern-color">{{landingPageData?.projects?.title}}</h2>
        <p class="lead fs-lg mb-11">{{landingPageData?.projects?.description}}</p>
      </div>
    </div>
  </div>
  <div class="container-fluid px-xl-0 pt-16 pt-md-18 pb-18 pb-md-20">
    <div class="swiper-container-2 swiper-auto nav-color nav-bottom nav-far" data-margin="40" data-nav="true" data-centered="true" data-loop="true" data-items-auto="true">
      <div class="swiper-2 overflow-visible">
        <div class="swiper-wrapper">
            <ng-container *ngTemplateOutlet="imgSwiper"></ng-container>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="projects.length > 3" class="container-fluid px-xl-0 pt-16 pt-md-18 pb-18 pb-md-20 pb-2 height">
    <div class="swiper-container-3 swiper-auto nav-color nav-bottom nav-far" data-margin="40" data-nav="true" data-centered="true" data-loop="true" data-items-auto="true">
      <div class="swiper-3 overflow-visible">
        <div class="swiper-wrapper">
            <ng-container *ngTemplateOutlet="imgSwiper"></ng-container>
        </div>
      </div>
    </div>
  </div>

  <div class="text-center mt-8 mb-15 mb-md-18 no-mt">
    <a routerLink="/projects/listing" class="btn btn-lg btn-primary rounded-xl default-background border-none">
      {{'landing.see_our_projects' | translateWithKeys}}
    </a>
  </div>


  <ng-template #imgSwiper>
    <div class="swiper-slide" *ngFor="let project of projects">
        <div class="spinner-center">
            <mat-spinner *ngIf="!project.image"></mat-spinner>
        </div>
        <figure class="rounded-xl shadow-xl">
          <img *ngIf="project.image" dynamicImage [baseImageSrc]="project.image" [displayResolutions]="[IMAGES_RESOLUTIONS.xs]" class="slider-img" [alt]="project.name">
        </figure>
      </div>
  </ng-template>
